import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-button',
  templateUrl: './form-button.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormButtonComponent extends FieldBaseComponent {}
